import { t } from 'i18next';
import PropTypes from 'prop-types';
import React from 'react';
import { withTranslation } from 'react-i18next';
import BaseDialogContainer from '../../baseContainers/BaseDialogContainer';
import DivContainer from '../../components/DivContainer';
import InputNumberComponent from '../../components/inputs/InputNumberComponent';
import Card from "react-bootstrap/Card";
import InputTextComponent from '../../components/inputs/InputTextComponent';
import UserRanksService from '../../services/UserRanksService';
import InputDropdownComponent from '../../components/inputs/InputDropdownComponent';

class RankDialog extends BaseDialogContainer {
    constructor(props) {
        super(props, new UserRanksService());
        this.state = {
            locale:props.locale,
            supportedLocales:props.supportedLocales,
            element: {
                id:undefined,
                translations:[],
                rangeFrom: undefined,
            },
            activeIndex: 0,
        };
    }
    translate(key) {
        const { t } = this.props;
        return t(key);
    }
    prepareElementBeforeRequest(element) {
        element.translations = Object.assign({}, element.translations);
        return element;
    }
   
    initBeforeSetElement() {
        const element =  this.props.element;
        const translations = [];
        if(this.props.viewMode === "EDIT"){
            this.state.supportedLocales.forEach((locale) => {
                let name = '';
                if(locale === this.state.locale){
                    name = element.name;
                }
                translations[locale] = {
                    name: name,
                };
            });
            this.setState({
                element:{
                    id:element.id,
                    rangeFrom:element.rangeFrom,
                    translations:translations
                }
            })
        }else{
            this.state.supportedLocales.forEach((element) => {
                translations[element] = {
                    name: '',
                };
            });
            this.setState({
                element:{
                    translations:translations
                }
            })
        }
    }
    renderFooter() {
        const footerItems = this.prepareFooterItems();
        if (footerItems !== undefined && footerItems.length > 0 && footerItems.filter((f) => f.rendered !== false)?.length > 0) {
            return (
                <React.Fragment>
                    <hr className='line-footer-user-dialog' />
                    {this.prepareFooter(footerItems)}
                </React.Fragment>
            );
        } else {
            return null;
        }
    }
    prepareFooterItems() {
        return [
            {
                label: t('ranks.dialog.save'),
                className: 'float-left',
                onClick: this.handleFormSubmit,
            },
            { label: t('details.cancel'), onClick: this.props.onHide, className: 'gray' },
        ];
    }
    createOrUpdate() {
        const element = this.state.element;
        const request = this.prepareElementBeforeRequest(element);
        this.scrollToTop();
        if (this._isMounted) {
            if (element.id === undefined || element.id === null) {
                this.service
                    .save(request)
                    .then((response) => {
                        this.afterAddSuccess(response);
                    })
                    .catch((err) => {
                        this.props.handleError ? this.props.handleError(err) : this.showErrorMessage(err.message, 10000);
                    });
            } else {
                this.service
                    .update(request)
                    .then((response) => {
                        this.afterUpdateSuccess(response);
                    })
                    .catch((err) => {
                        this.props.handleError ? this.props.handleError(err) : this.showErrorMessage(err.message, 10000);
                    });
            }
        }
    }

    renderHeader() {
        const { t, viewMode } = this.props;
        return (
            <DivContainer colClass='col-12'>
                <DivContainer colClass='col-12'>
                    <label>{viewMode === 'NEW' ? t('ranks.dialog.create') : t('ranks.dialog.update')}</label>
                </DivContainer>
            </DivContainer>
        );
    }
    getContainerListName() {
        return 'ranks-list-container';
    }

    getAddSucces() {
        return t('global.addSuccess');
    }
    getUpdateSucces() {
        return t('global.updateSuccess');
    }

    renderDetails() {
        const locale = this.state.locale;
        return (

            <Card className='input-card-userdialog'>
                <div className='row align-items-center'>
                    {/* TODO: przyszlosciowo */}
                {/* <InputDropdownComponent
                        id='locale'
                        name='locale'
                        colClass='col-xl-2 col-lg-2 col-md-2 col-sm-6'
                        label={t('global.languageChooser')}
                        validator={this.validator}
                        validators='not_required'
                        value={this.state.locale}
                        options={this.state.supportedLocales}
                        insideTable
                        viewMode={this.props.viewMode}
                        onChange={this.handleChange}
                        rendered
                        showClear={false}
                        stateField={``}
                    /> */}
                    <InputTextComponent
                            id={`name`}
                            name='name'
                            label={t('rank.name')}
                            colClass='col-xl-6 col-lg-6 col-md-6 col-sm-12'
                            value={this.state.element?.translations[locale]?.name}
                            validator={this.validator}
                            validators='required|max:255'
                            onChange={this.handleChange}
                            viewMode={this.props.viewMode}
                            stateField={`element.translations[${locale}]`}
                    />
                    <InputNumberComponent
                            id={`rangeFrom`}
                            name='rangeFrom'
                            label={t('rank.since')}
                            colClass='col-xl-6 col-lg-6 col-md-6 col-sm-6'
                            value={this.state.element?.rangeFrom}
                            validator={this.validator}
                            mode='decimal'
                            validators={`required|number_min_float:${this.props.minRangeFrom}|number_max_float:${this.props.maxRangeFrom}`}
                            minFractionDigits={0}
                            maxFractionDigits={1}
                            onChange={this.handleChange}
                            viewMode={this.props.viewMode}
                    />
                </div>

            </Card>
        );
    }
}

RankDialog.defaultProps = {
    visible: false,
};

RankDialog.propTypes = {
    viewMode: PropTypes.string,
    visible: PropTypes.bool,
    onHide: PropTypes.func,
    afterSave: PropTypes.func,
};

export default withTranslation()(RankDialog);
